{
  "ascending": "augošā secībā",
  "ascendingSort": "kārtots pēc kolonnas {columnName} augošā secībā",
  "columnSize": "{value} pikseļi",
  "descending": "dilstošā secībā",
  "descendingSort": "kārtots pēc kolonnas {columnName} dilstošā secībā",
  "resizerDescription": "Nospiediet Enter, lai sāktu izmēru mainīšanu",
  "select": "Atlasīt",
  "selectAll": "Atlasīt visu",
  "sortable": "kārtojamā kolonna",
  "collapse": "Sakļaut",
  "expand": "Izvērst"
}
